let searchFormTrigger = document.getElementById("search-form-toggle");
let searchForm = document.getElementById("search-form");
let closeForm = document.getElementById("search-close");

searchFormTrigger.addEventListener("click", function (e) {
  searchForm.classList.toggle("search-form--open");
  this.setAttribute(
    "aria-expanded",
    `${!(this.getAttribute("aria-expanded") === "true")}`
  );
  closeForm.setAttribute(
      "aria-expanded",
      `${!(closeForm.getAttribute("aria-expanded") === "true")}`
  );
  document.getElementById("search-form-input").focus();
  this.classList.toggle("search-toggle--form-open");
});

closeForm.addEventListener("click", function (e) {
  searchForm.classList.remove("search-form--open");
  searchFormTrigger.setAttribute("aria-expanded", "false");
  searchFormTrigger.classList.remove("search-toggle--form-open");
  this.setAttribute("aria-expanded", "false");
});

document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    searchForm.classList.remove("search-form--open");
    searchFormTrigger.setAttribute("aria-expanded", "false");
    searchFormTrigger.classList.remove("search-toggle--form-open");
    closeForm.setAttribute("aria-expanded", "false");
  }
});
